<template>
  <div class="home-carousel">
    <el-carousel height="62.5rem" :interval="5000" trigger="click" arrow="never" @change="sendIndex">
      <el-carousel-item v-for="(item, index) in photoList" :key="item.index">
        <img loading="lazy" v-if="[0, 1, 2].includes(index)" class="carousel-text" :class="carouselText[index]"
          :src="textList[index].url" alt="">
        <!-- <img class="home-carousel-photo" :src='item.photo' alt=""> -->
        <img loading="lazy" class="home-carousel-photo" :src='item.url' alt="">
      </el-carousel-item>
    </el-carousel>
    <img loading="lazy" class="home-bottom-data" src="@/assets/img/home/bottomData.png" alt="">
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  props: [],
  data() {
    return {
      photoList: [
        { url: require('@/assets/img/home/homeBg0.png') },
        { url: require('@/assets/img/home/homeBg1.png') },
        { url: require('@/assets/img/home/homeBg2.png') },
      ],
      carouselText: ['carouselText0', 'carouselText1', 'carouselText2'],
      textList: [
        { url: require('@/assets/img/home/homeBg0Text.png') },
        { url: require('@/assets/img/home/homeBg2Text.png') },
        { url: require('@/assets/img/home/homeBg1Text.png') },
      ],
    }
  },
  created() {
    // this.getPhotoData()
  },
  mounted() {

  },
  methods: {
    getPhotoData() {
      this.$apis.home_page_photo().then(res => {
        this.photoList = res.data
      })
    },
    sendIndex(index) {
      this.$emit('transmit', index)
    }
  },
}
</script>

<style lang='scss' scoped>
.home-carousel {
  position: relative;

  .home-carousel-photo {
    width: 120rem;
    height: 62.5rem;
  }

  .carousel-text {
    position: absolute;
    z-index: 110;

  }

  .carouselText0 {
    left: 6.25rem;
    top: 25rem;
    width: 64.75rem;
  }

  .carouselText1 {
    left: 50%;
    top: 50%;
    width: 75rem;
    transform: translate(-50%, -48%);
  }

  .carouselText2 {
    right: 8.125rem;
    top: 25rem;
    width: 731px;

  }

  .home-bottom-data {
    position: absolute;
    bottom: 1.25rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: 64.8125rem;
    height: 11.6875rem;
  }
}
</style>

<style></style>